import React from "react";

const FormContext = React.createContext({ values: {} });
const FormProvider = FormContext.Provider;
const FormConsumer = FormContext.Consumer;

export default FormContext;
export { FormProvider, FormConsumer };
